const roleColors: Record<string, string> = {
  "Contratante": "bg-primary-100 text-primary-700",
  "Gestor do projeto": "bg-primary-50 text-primary-600",
  "Responsável técnico": "bg-accent-100 text-accent-700",
  "Técnico de campo": "bg-secondary-100 text-secondary-700",
  "Analista GIS": "bg-accent-50 text-accent-600",
  "Fiscal ambiental": "bg-warning-100 text-warning-700",
  "Órgão licenciador": "bg-primary-100 text-primary-700",
  "Órgão gestor": "bg-primary-50 text-primary-600",
  "Proprietário/possuidor": "bg-secondary-100 text-secondary-700",
  "Executor de manejo": "bg-accent-100 text-accent-700",
  "Executor de poda": "bg-accent-50 text-accent-600",
  "Executor de supressão": "bg-danger-100 text-danger-700",
  "Executor de replantio": "bg-primary-100 text-primary-700",
  "Responsável por compensação": "bg-warning-100 text-warning-700",
  "Validador técnico": "bg-secondary-50 text-secondary-600",
  "Emissor de documento": "bg-background-100 text-foreground-600",
  "Interessado externo": "bg-background-200 text-foreground-500",
  "Consulta pública": "bg-background-100 text-foreground-600",
  "Consultor externo": "bg-accent-50 text-accent-600",
};

interface PartyRoleBadgeProps {
  role: string;
}

export default function PartyRoleBadge({ role }: PartyRoleBadgeProps) {
  const colors = roleColors[role] || "bg-background-100 text-foreground-500";
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colors}`}>
      {role}
    </span>
  );
}